import React from 'react';
import { Helmet } from 'react-helmet-async';

const SchemaOrg = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Décors Multifestif",
    "description": "Spécialiste en décorations de ballons et événements spéciaux à Montréal",
    "image": "https://decorsmultifestif.com/logo-dm.png",
    "telephone": "+1-514-XXX-XXXX",
    "email": "info@decorsmultifestif.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Montréal",
      "addressRegion": "QC",
      "addressCountry": "CA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "45.5017",
      "longitude": "-73.5673"
    },
    "url": "https://decorsmultifestif.com",
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "16:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/decorsmultifestif",
      "https://www.instagram.com/decorsmultifestif"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaOrg;
